<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormBrandingCode
      :BrandingCode="editBrandingCode"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormBrandingCode from '../components/FormBrandingCode.vue';

export default {
  components: {
    FormBrandingCode,
  },
  name: 'EditBrandingCode',
  module: 'BrandingCode',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing BrandingCode. Default to {}.
      */
      editBrandingCode: {},
      /**
       * Query Id for BrandingCode
       */
      brandingCodeId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('brandingCodes', ['brandingCodes', 'brandingCode']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.brandingCodeId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_brandingCode(this.brandingCodeId);
      this.editBrandingCode = this.brandingCode;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('brandingCodes', ['LOAD_brandingCode', 'CREATE_brandingCode', 'UPDATE_brandingCode']),
    /** Method used to save the item
     */
    async save(brandingCode) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_brandingCode(brandingCode);
      } else {
        await this.UPDATE_brandingCode(brandingCode);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListBrandingCode' });
    },
  },
};
</script>

<docs>
# EditBrandingCode example

'''js
<EditBrandingCode :BrandingCode="BrandingCode" />
'''
</docs>
